/**
 * Ask thread history (block 42), newest activity first. Ungated: an expired
 * user still lists their threads.
 */
import { useInfiniteQuery } from "@tanstack/react-query";
import { getNookClient } from "../client.js";
import { queryKeys } from "../query-keys.js";
export function useAskThreads() {
    return useInfiniteQuery({
        queryKey: queryKeys.ask.threads(),
        queryFn: ({ pageParam }) => getNookClient().listAskThreads(pageParam),
        initialPageParam: null,
        getNextPageParam: (last) => last.nextCursor,
    });
}
//# sourceMappingURL=use-ask-threads.js.map